import { blue } from 'bold-ui/lib/styles/colors'

import { SoapSection } from '../SoapSection'
import { ObjetivoForm, ObjetivoFormProps } from './ObjetivoForm'

export function ObjetivoSection(props: Readonly<ObjetivoFormProps>) {
  return (
    <SoapSection initial='O' title='Objetivo' color={blue}>
      <ObjetivoForm {...props} />
    </SoapSection>
  )
}
